import { useEffect } from 'react'
import { useLocaleContext } from 'fbtee'
import { setAnalyticsUserProperty } from '../lib/analytics'
import { appShell } from '../lib/appShell'
import { useAudience } from './useAudience'

// Mounted in RootLayout so every session is tagged, not only ones that open a
// groups page.
export function useAnalyticsUserProperties() {
  const { audience, crew } = useAudience()
  const { locale } = useLocaleContext()

  useEffect(() => setAnalyticsUserProperty('app_shell', appShell()), [])
  useEffect(() => setAnalyticsUserProperty('ui_locale', locale), [locale])
  useEffect(() => {
    if (audience) setAnalyticsUserProperty('audience', audience)
  }, [audience])
  useEffect(() => {
    if (crew) setAnalyticsUserProperty('crew_status', crew)
  }, [crew])
}
